import { DevHubButton } from '@devxdiscover/devhub-ui';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ExperimentalOnboardingModal } from './OnboardingModal';

interface OnboardIdeaButtonProps {
  size?: 'small' | 'medium' | 'large';
  variant?: 'text' | 'outlined' | 'contained';
  onSuccess?: (createdApp?: {
    applicationId: number;
    name: string;
    description: string;
    ownerLogin: string;
  }) => void;
}

/**
 * Reusable button component for onboarding a new idea
 * Opens the onboarding modal directly (action flow)
 * @param props - The component props
 * @param props.size - Button size variant
 * @param props.variant - Button style variant
 * @param props.onSuccess - Callback fired when onboarding succeeds
 */
export const OnboardIdeaButton = ({
  size = 'small',
  variant = 'contained',
  onSuccess,
}: OnboardIdeaButtonProps) => {
  const navigate = useNavigate();
  const [onboardingOpen, setOnboardingOpen] = useState(false);

  const handleOpenOnboarding = () => {
    setOnboardingOpen(true);
  };

  const handleCloseOnboarding = () => {
    setOnboardingOpen(false);
  };

  const handleOnboardingSuccess = (createdApp?: {
    applicationId: number;
    name: string;
    description: string;
    ownerLogin: string;
  }) => {
    if (onSuccess) {
      onSuccess(createdApp);
    }
  };

  const handleViewIdeas = () => {
    navigate('/action-center/my-ideas');
  };

  return (
    <>
      <DevHubButton
        variant={variant}
        size={size}
        onClick={handleOpenOnboarding}
        buttonColor="pinkPurple"
        data-gtm-event="experimental-onboarding-start"
      >
        Onboard an Idea
      </DevHubButton>

      <ExperimentalOnboardingModal
        open={onboardingOpen}
        onClose={handleCloseOnboarding}
        onSuccess={handleOnboardingSuccess}
        onViewIdeas={handleViewIdeas}
      />
    </>
  );
};
